import { InventarioAvanzado } from "../../components";
import "./stylesInventarioNuevo.scss";

export const InventarioNuevo = () => <InventarioAvanzado />;
